import * as React from 'react';

export interface ICheckingProps {}

export default class Checking extends React.Component<ICheckingProps> {
  public render() {
    return <div>checking</div>;
  }
}
